import { Award, Shield, Users } from 'lucide-react';

export const services = [
    {
        title: "תותבות שיניים חדשות",
        description: "תותבות שיניים חדשות באותו היום!",
        icon: Award
    },
    {
        title: "תיקון תותבות",
        description: "תיקון תותבות תוך חצי שעה",
        icon: Users
    },
    {
        title: "ריפודי תותבות",
        description: "ריפוד תותבות במקום",
        icon: Shield
    },
];

export const testimonials = [
    {
        name: "פסיה שמעוני",
        text: "היום אני מחייכת בגאווה!",
        rating: 5
    },
    {
        name: "עמי טל",
        text: "שירות ומקצוענות מעולים!",
        rating: 5
    },
    {
        name: "אילה בר",
        text: "תודה שעזרת לי לחייך!",
        rating: 5
    }
];

export const stats = [
    { number: "40+", label: "שנות ניסיון" },
    { number: "10,000+", label: "מטופלים מרוצים" }
];

export const contactInfo = {
    phone: "+972544933286",
    whatsapp: "https://wa.me/972544933286",
    facebook: "https://m.me/elimagdaci",
    location: "geo:31.89738,34.81021?q=בית הפועלים 6, רחובות",
    locationFallback: "https://www.google.com/maps/dir/?api=1&destination=בית%20הפועלים%206,%20רחובות",
    waze: "https://waze.com/ul/hsv8v2neyu",
    address: "בית הפועלים 6, רחובות",
    coordinates: {
        lat: 31.89738,
        lng: 34.81021
    }
};

// Company information for SEO
export const companyInfo = {
    name: "מעבדת שיניים טופ-טק",
    englishName: "Top-Tech Dental Lab",
    city: "רחובות",
    fullAddress: "בית הפועלים 6, רחובות",
    description: "מעבדת שיניים מובילה ברחובות המתמחה בתיקון תותבת, ריפוד תותבות שיניים. שירות מקצועי ואיכותי למרפאות שיניים.",
    keywords: [
        "טופ-טק", "טופ טק", "מעבדת שיניים רחובות", "מעבדת שיניים",
        "תותבות שיניים רחובות", "תותבות רחובות", "שיניים רחובות",
        "בית הפועלים 6", "מעבדת שיניים טופ טק רחובות", "תיקון תותבות רחובות",
        "תיקון תותבת רחובות", "מעבדת שיניים טופ-טק", "ריפוד תותבת רחובות",
        "שיניים טופ טק", "תותבות", "תותבות שיניים ברחובות"
    ]
};

// SEO content for better search visibility
export const seoContent = {
    title: "מעבדת שיניים טופ-טק רחובות | תיקון תותבות שיניים, תותבות שיניים חדשות",
    description: "מעבדת שיניים טופ-טק ברחובות - מובילים בתחום תותבות שיניים חדשות , תיקון תותבות. בית הפועלים 6, רחובות. שירות מקצועי ואמין למרפאות שיניים.",
    keywords: "מעבדת שיניים רחובות, טופ-טק, תותבות שיניים רחובות, תותבות חדשות רחובות, תיקון תותבות רחובות, בית הפועלים 6",
    author: "מעבדת שיניים טופ-טק",
    robots: "index, follow",
    canonical: "https://www.top-tech-lab.net"
};